import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

// Kept apart from the data context so a selection only re-renders its subscribers
// (list, calendar, map), not everything reading orders or settings.
interface WorkOrderSelectionContextValue {
  selectedId: number | null;
  toggleSelect: (id: number) => void;
  // Sets the selection outright (the map's asset card); null clears it.
  select: (id: number | null) => void;
}

const WorkOrderSelectionContext = createContext<WorkOrderSelectionContextValue | null>(null);

const WorkOrderSelectionProvider = ({ children }: { children: React.ReactNode }) => {
  const [selectedId, setSelectedId] = useState<number | null>(null);

  const toggleSelect = useCallback((id: number) => {
    setSelectedId((prev) => (prev === id ? null : id));
  }, []);

  const value = useMemo(() => ({ selectedId, toggleSelect, select: setSelectedId }), [selectedId, toggleSelect]);

  return <WorkOrderSelectionContext.Provider value={value}>{children}</WorkOrderSelectionContext.Provider>;
};

const useWorkOrderSelection = () => {
  const context = useContext(WorkOrderSelectionContext);
  if (!context) throw new Error('useWorkOrderSelection must be used within WorkOrdersProvider');
  return context;
};

export { WorkOrderSelectionProvider, useWorkOrderSelection };
